import { ApplicationIds } from "@next-platform/packages-ts-types";

import { ANALYTICS_DOCS_URL_BY_APPLICATION, ANALYTICS_DOCS_URL_FALLBACK } from "@/pages/CreatorAnalytics/constants";

/**
 * Resolves the per-application creator-analytics documentation URL.
 *
 * Looks up the supplied application in {@link ANALYTICS_DOCS_URL_BY_APPLICATION}
 * and falls back to {@link ANALYTICS_DOCS_URL_FALLBACK} (SpicyChat) when
 * no dedicated guide is registered for the app.
 *
 * The input is typed loosely on purpose: `useApp()` returns
 * `applicationId` as `string | undefined` (the runtime value is an
 * `ApplicationIds` member but the type signature doesn't enforce it),
 * and partner-only apps may legitimately have no entry in the map.
 */
const getAnalyticsDocsUrl = (applicationId: ApplicationIds | string | null | undefined): string => {
  if (!applicationId) {
    return ANALYTICS_DOCS_URL_FALLBACK;
  }
  return ANALYTICS_DOCS_URL_BY_APPLICATION[applicationId as ApplicationIds] ?? ANALYTICS_DOCS_URL_FALLBACK;
};

export default getAnalyticsDocsUrl;
